import React from 'react';
import PlanBox from '../PlanBox';
import PlanFeatureList from '../PlanFeatureList';

import styles from './EnterpriseCard.css';

const availableFeatures = [
  {
    description: 'Unlimited users',
    toolTip: 'With Marvel Enterprise, you decide how many users you need.',
  },
  {
    description: 'Unlimited projects',
    toolTip: '',
  },
  {
    description: 'Unlimited User Tests',
    toolTip:
      'Scale your testing process with no limits on the amount user tests and results',
  },
  {
    description: 'Download prototypes and designs',
    toolTip:
      'Download your prototypes and designs offline and present them without having to worry about connectivity',
  },
  {
    description: 'Dedicated support',
    toolTip: 'Get prioritised support and super speedy response time',
  },
  {
    description: 'Remove Marvel branding',
    toolTip: 'Hide the Marvel logo on your prototypes',
  },
  {
    description: 'Invite-only projects',
    toolTip: 'Hide sensitive projects from the rest of your workspace',
  },
  {
    description: 'Advanced security settings',
    toolTip: 'Restrict access to projects, links and more',
  },
  {
    description: 'Single Sign-On (SSO)',
    toolTip:
      'We support all SSO providers and work with IT teams to get everything up and running',
  },
  {
    description: 'Invoice/custom billing',
    toolTip: 'Pay by bank transfer and custom invoicing requirements',
  },
];

function EnterpriseCard() {
  return (
    <div>
      <PlanBox space="m" kind="enterprise">
        <div className="padding-xxs">
          <div className={styles.header}>
            <div className={styles.name}>Enterprise</div>
            <div className={styles.description}>Built for large orgs</div>
          </div>
          <div className={styles.pricing}>Let's chat</div>
          <a
            className={styles.button}
            data-bypass
            href="/enterprise/request-quote/"
          >
            Request a Quote
          </a>
        </div>
      </PlanBox>
      <div className={styles.features}>
        <PlanFeatureList features={availableFeatures} />
      </div>
    </div>
  );
}

export default EnterpriseCard;



// WEBPACK FOOTER //
// ./src/components/modules/Pricing/EnterpriseCard/index.js